import { ServicesSunsetService } from './../components/services-sunset.service';
import {  Component,  OnInit  } from '@angular/core';
import { Router } from '@angular/router';
import { Usuario } from './login.entity';
import { NgForm } from '@angular/forms';
import { Empresa } from '../components/configuracion/configuracion.entity';
import { Filtros } from '../components/reportes/rinventario/rinventario.entity';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  btnLogin: boolean = false;
  usuario = new Usuario();
  mensaje = '';
  selempresa: boolean = false;
  activo: number =0;
  empresa: Empresa = new Empresa();
  bpassword: boolean =false;
  strLogin: string = "";
  filtros: Filtros = new Filtros();
  procesando: boolean = false;

  constructor(private router: Router, private _servicio: ServicesSunsetService) { 

  }


 

  ngOnInit() {
 
     this.strLogin ='Login'
    this.bpassword = true;
    this.empresa = new Empresa();
    this.selempresa = false;
    this.activo = 0;
    this.btnLogin = false;
    sessionStorage.setItem('token', '');
    this.procesando = false;
    // filtro de producción 
    
    this.filtros = new Filtros();
    sessionStorage.setItem('filtroProduccion', JSON.stringify(this.filtros) );
    
   
    
    // filtro de producción
    
  }
  ojoVerificar() {
    
    this.bpassword = !this.bpassword;

  }

  onLogin() {

    if (this.strLogin === 'Login') {

      this.strLogin = 'Inicio'

    } else {

      this.strLogin = 'Login'


    }

  }

  onSubmit(forma: NgForm)  {

    this.btnLogin = true;
    this.procesando = true;
    this.mensaje = "";

    try {

      this._servicio.ValidarUsuario(this.usuario).subscribe (

       

        (data: any) => {
          
          

        
           if (data.usuarios.length > 0) {
      
            sessionStorage.setItem('token', data.usuarios[0].token);
            sessionStorage.setItem('codigo', data.usuarios[0].id);
            sessionStorage.setItem('usuario', data.usuarios[0].nombre);
            sessionStorage.setItem('correo', this.usuario.login);
            sessionStorage.setItem('tipo_usuario', data.usuarios[0].tipo);
            sessionStorage.setItem('menu', data.usuarios[0].menu);
            sessionStorage.setItem('excel', data.usuarios[0].excel);
            sessionStorage.setItem('pdf', data.usuarios[0].pdf);
  
              this.mostrarEmpresas(true);
              this.procesando=false;
  
          } else {
            this.procesando=false;
            this.mensaje = data.msg;
          }
  
          this.btnLogin = false;
  
        }, err => {
          this.mensaje = err.message;
          this.btnLogin = false;
          this.procesando = false;

      });
  
      
    } catch (error) {
      
      console.log(error);
      this.mensaje = "Error en solicitud";
      this.btnLogin = false;
      this.procesando = false;
    }

  



  }

  mostrarEmpresas(valor:boolean) {


    this.selempresa = valor;
    this.activo++;


  setTimeout(() => {

    if (valor === false) {

      this.irStarter()

    }} , 500);

  }


 async delay(ms: number) {
    return new  Promise( resolve => setTimeout(resolve, ms) );
  }

  DesactivarMensaje()  {
    this.mensaje = '';
  }

   irStarter() {

    // , {usuario: sessionStorage.getItem('usuario')}

    if (sessionStorage.getItem('token')?.toString() !== '') {
          this.router.navigate(['/home']);
        } else {

          this.mensaje = 'Verifique el usuario o la contraseña';

        }
  }

  consultarEmpresa() {

     this._servicio.MostrarEmpresa().subscribe (

       (data: any) => {

         this.empresa = data[0];

         sessionStorage.setItem('empresa', JSON.stringify(this.empresa));

       });

 }


}
